<!-- <section class="w-screen h-screen blur-sm absolute top-0 right-0"> -->
<div class="bg-white p-3 rounded-xl shadow-md">
  <img
    [src]="searchBoxService.accommodation() != 'ecolodge' ? 'assets/images/2-loading.svg' : 'assets/images/Banner-Loading.svg'"
    class="h-[250px] w-full rounded-xl object-contain">
</div>
<!-- <img src="https://cdn.iranhotelonline.com/images/2-loading.svg" class="h-[450px] w-full rounded-xl">
<img src="https://cdn.iranhotelonline.com/images/3-loading.svg" class="h-[450px] w-full rounded-xl"> -->

<div class="w-full p-3 bg-white rounded-xl mt-3 flex justify-start items-center">
  <p class="text-black-300 lg:text-base text-sm" [innerHTML]=" modaldata.navigationText ??
    'در حال جستجوى بهترين واحد اقامتی براى شما'">
   
  </p>
  <div class="typing-animation scale-[0.65] mr-1 rotate-180">
    <span class="!bg-blue-500"></span>
    <span class="!bg-yellow-500"></span>
    <span class="!bg-blue-500"></span>
  </div>
</div>
<!-- </section> -->